import React from 'react';

// Badge numérico de no leídos. Sigue el Design System: fondo brass (acento
// jerárquico para llamar la atención), texto ink, Manrope bold, mínimo 18px.
// Oculto si count <= 0; muestra "99+" cuando count >= 100.
export default function UnreadBadge({ count, style }) {
  if (!count || count <= 0) return null;
  const label = count >= 100 ? '99+' : String(count);
  return (
    <span
      aria-label={`${count} mensajes sin leer`}
      style={{
        position: 'absolute',
        top: -6,
        right: -6,
        minWidth: 18,
        height: 18,
        padding: '0 5px',
        borderRadius: 999,
        background: 'var(--troly-brass, #C8A55B)',
        color: 'var(--troly-ink, #0E1116)',
        fontFamily: "'Manrope', system-ui, sans-serif",
        fontWeight: 700,
        fontSize: 10,
        lineHeight: '18px',
        textAlign: 'center',
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        boxShadow: '0 1px 4px rgba(0,0,0,.25)',
        pointerEvents: 'none',
        ...style,
      }}
    >
      {label}
    </span>
  );
}
